import React, { useState, useRef } from 'react';
import ReactModal from 'react-modal';
import NavigationMap from '@components/operatorLobby/NavigationMap'


const server = `${process.env.REACT_APP_BACKEND_URL}:${process.env.REACT_APP_BACKEND_PORT}`;

export default function useMissionPlanModal({ token, vehicle }) {
    const [errorMessage, setErrorMessage] = useState(null);
    const [isOpen, setOpen] = useState(false);
    const [enableSend, setEnableSend] = useState(true);
    const departureTimeInputRef = useRef();
    const arrivalTimeInputRef = useRef();
    const navigationMapRef = useRef();

    function initFields() {
        setEnableSend(true);
        departureTimeInputRef.current.value = vehicle.missionPlan.departureTime;
        arrivalTimeInputRef.current.value = vehicle.missionPlan.arrivalTime;
    }

    function toggle() {
        setOpen(isOpen => !isOpen);
    }

    function updateMissionPlan(event) {
        setEnableSend(false);

        const authHeaders = new Headers({
            'Content-Type': 'application/json;charset=utf-8',
            'Authorization': `Bearer ${token}`
        });

        const body = JSON.stringify({
            origin: navigationMapRef.current.getOrigin(),
            destination: navigationMapRef.current.getDestination(),
            departureTime: departureTimeInputRef.current.value,
            arrivalTime: arrivalTimeInputRef.current.value,
        });

        fetch(`${server}/vehicle/${vehicle.id}/update-mission-planning`, {
            method: 'POST',
            headers: authHeaders,
            body: body,
        }).then((answer) => {
            if(answer.status === 400) {
                setErrorMessage('Unable to find a route.');
                setEnableSend(true);
            } else {
                setErrorMessage(null);
                setOpen(false);
            }
            return true;
        }).catch(error => {
            console.error(error);
            setErrorMessage(error.data);
            setEnableSend(true);
            return false;
        });

        event.preventDefault();
    }
    
    const component = <ReactModal isOpen={isOpen} onAfterOpen={initFields}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="destinationModalLabel">Edit mission plan</h5>
            </div>
            <div className="modal-body">
                {errorMessage && <div className="p-3 border bg-light text-danger">Error: {errorMessage}</div>}
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor="departure-time" className="form-label">Departure</label>
                            <input type="datetime-local" className="form-control" ref={departureTimeInputRef} id="departure-time" name="departure time"></input>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor="arrival-time" className="form-label">Arrival</label>
                            <input type="datetime-local" className="form-control" ref={arrivalTimeInputRef} id="arrival-time" name="arrival time"></input>
                        </div>
                    </div>
                    <div className="col-12" style={{height: '10px'}}></div>
                    <div className="col-12">
                        <NavigationMap ref={navigationMapRef} vehicle={vehicle} isReadOnly={false}/>
                    </div>
                    <div className="col-12">
                        <div style={{float:'right'}}>
                            <button type="button" className="btn btn-primary m-1" onClick={updateMissionPlan} disabled={!enableSend}>Update</button>
                            <button type="button" className="btn btn-primary m-1" onClick={() => setOpen(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ReactModal>

    return { toggle, component };
};

